module.exports = __webpack_public_path__ + "static/img/s11.81016b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoimages/s11.png
// module id = 2X1V
// module chunks = 0